"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const tab_1 = require("@kyruus/tab");
const messages_1 = __importDefault(require("../../lib/messages"));
const tracking_utils_1 = require("../../lib/tracking.utils");
const ProviderNavigation = (0, intl_1.injectIntl)(({ navOptions, track, intl }) => {
    const getNavLabel = (label) => {
        if (typeof label === 'string') {
            return label;
        }
        return intl.formatMessage(label);
    };
    const navigationTabs = navOptions
        .filter(({ rendered }) => rendered === true)
        .map((navOption) => (Object.assign(Object.assign({}, navOption), { label: getNavLabel(navOption.label) })));
    const onActivate = (_event, _id, metadata) => {
        if (metadata === null || metadata === void 0 ? void 0 : metadata.name) {
            (0, tracking_utils_1.trackProfileNavClick)(track, metadata.name);
        }
    };
    const getTabControlId = (tabId) => {
        return `profile-nav-${tabId}`;
    };
    return (react_1.default.createElement(tab_1.DropdownTabs, { "aria-label": intl.formatMessage(messages_1.default.profileNavAriaLabel), id: "profile-nav", tabs: navigationTabs, elevation: 0, onActivate: onActivate, getTabControlId: getTabControlId, renderAsNav: true }));
});
exports.default = ProviderNavigation;
//# sourceMappingURL=profile-navigation.js.map